import documentApi, { DocumentDetailDTO } from "../api/document.api"
import Button from "../components/Button";
import Icon from "../components/icon/Icon";
import Table, { TableProps } from "../components/table/Table"
import { useTableInstance } from "../components/table/TableContext"
import { toHumanDateTime } from "../libs/datetime"

import plusWhiteSvg from "./assets/images/plus-white.svg";
import download01Svg from "./assets/images/download-01.svg";
import download02Svg from "./assets/images/download-02.svg";
import trashSvg from "./assets/images/trash-01.svg"
import fileSvg from "./assets/images/file-04.svg"
import arrowRightSvg from "./assets/images/arrow-right.png"
import previewPng from "./assets/images/eye.png";

import "./TranslationDashboard.scss"
import { useEffect, useState } from "react";
import { Flex } from "antd";
import { useMask } from "../components/mask/Mask";
import { DeleteModal, ChoiceModal } from "../components/modal/Modal";
import Status from "../components/table/Status";
import ProgressBar from "../components/table/ProgressBar";
import Notification from "../components/notification/Notification";
import { useNavigate } from "react-router-dom";
import { Pagination } from 'antd';
import { useTranslate } from "../components/language";



export default (props: {docId?: string}) => {
    const {
        docId
    } = props
    const {t} = useTranslate()
    const navigate = useNavigate()
    const tableInstance = useTableInstance()
    const {
        refresh,
        changeTotal,
    } = tableInstance
    const {
        render: maskRender,
        show: showMask,
        close: closeMask
    } = useMask()

    // const {statusRender, docStatus, notifacationRender} = useDocumentRuntime(docId)

    const dataLoader: TableProps['dataLoader'] = async (params) => {
        
        const {
            page,
            pageSize,
        } = params

        const skip = (page - 1) * pageSize
        const limit = pageSize

        console.log(`dataLoader: ${JSON.stringify(params)}`)

        const reqData = {skip, limit}
        const res = await documentApi.list(reqData)
        changeTotal(res.total)
        return res.data

    }

    const doDownload = (record: any) => {
        if(record.status !== "COMPLETED"){
            return
        }
        showMask(
            <ChoiceModal
                title={t("Download Format")}
                content={t("Please select the format you want to download")}
                onCancel={() => closeMask()}
                onChoice1={() => handleDownload(record, 'pdf')}
                onChoice2={() => handleDownload(record, 'pptx')}
                choice1Label={t("PDF")}
                choice2Label={t("PPTX")}
            />
        )
    }

    const handleDownload = (record: any, format: 'pdf' | 'pptx') => {
        // 注意：API当前不直接支持format参数，但我们仍然让用户进行选择
        // 这里可以根据需要添加额外的逻辑，比如记录用户的格式偏好
        console.log(`User selected format: ${format}`);
        documentApi.getDownloadUrl({id: record.id}, format).then(download_url => {
            window.open(download_url)
            closeMask()
        }).catch(error => {
            console.error('Download failed:', error)
            closeMask()
        })
    }

    const doDelete = async (record: any) => {
        //TODO
        await documentApi.remove({id: record.id})
        refresh()
        closeMask()
        
    }
    

    const onDeleteHandle = (record: any) => {
        //TODO
        showMask(
            <DeleteModal
                title={t("Delete Translation")}
                content={t("Are you sure you want to delete this translation?")}
                onCancel={() => closeMask()}
                onConfirm={() => {return doDelete(record)}}

            ></DeleteModal>
        )
        
    }

    const gotoNewTranslation = () => {
        navigate("/app/translation")
    }

    const readyForPreview = (record: any) => {
        return record.status === "WAITING_PAYMENT" || record.status === "COMPLETED"
    }

    


    const cols: TableProps['cols'] = [
        {
            label: t("Translation Process"),
            name: "filename",
            render(record, value, idx) {
                return (
                    <Flex align="center" gap={12} onClick={() => {
                        if(readyForPreview(record)){
                            navigate(`/app/preview?docId=${record.id}`)
                        }
                    }}>
                        <Icon src={fileSvg} size={40}/>
                        {value}
                    </Flex>
                )
            },
        },
        {
            label: t("Translation status"),
            name: "status",
            width: 340,
            render(record, value, idx) {
                if (readyForPreview(record)) {
                    return <Status label={value} type={value} onClick={() => {
                        if(readyForPreview(record)){
                            navigate(`/app/preview?docId=${record.id}`)
                        }
                    }} />
                }
                return <DocumentRuntime docId={record.id} />
                // if(docId && record.docId == docId){
                //     return useDocumentRuntime(record.id)
                // }
                // return statusRender()
                // return (
                //     <Status label={value} type={value} onClick={() => {
                //         if(readyForPreview(record)){
                //             navigate(`/preview?docId=${record.id}`)
                //         }
                //     }} />
                // )
            }
        },
        {
            label: t("Date created"),
            name: "created_at",
            width: 340,
            render(record, value, idx) {
                return toHumanDateTime(value)
            },
        },
        {
            label: "",
            name: "status",
            width: 80,
            render(record, value, idx) {
                if(record.status === "WAITING_PAYMENT"){
                    return (
                        <Icon src={previewPng} size={20} padding={16} hoverable onClick={() => {navigate(`/app/preview?docId=${record.id}`)}}/>
                    )
                }
                if (record.status === "COMPLETED") {
                    return (
                        <Icon src={download02Svg} size={20} padding={16} hoverable={value == "COMPLETED"} onClick={() => doDownload(record)}/>
                    )
                }
                return <DownloadRuntime docId={record.id} />
            }
        },
        {
            label: "",
            name: "",
            width: 80,
            render(record, value, idx) {
                return (
                    <Icon src={trashSvg} size={20} padding={16} hoverable onClick={() => onDeleteHandle(record)}/>
                )
            }
        }
    ]

    const emptyRender = (
        <>empty</>
    )

    

    const headerRender = (
        <div className="translation-dashboard-header">
            <div className="title">{t("Recent Translation History")}</div>
            <Button.Primary onClick={() => {gotoNewTranslation()}} >

                <Flex align="center" gap={2}>
                    <Icon src={plusWhiteSvg} size={20}></Icon>
                    {t("New Translation")} 
                </Flex>
            </Button.Primary>
        </div>
    )

    useEffect(() => {
        refresh()
    }, [])


    return (
        <div className="translation-dashboard">
            {/* {notifacationRender()} */}
            <Table
                instance={tableInstance}
                dataLoader={dataLoader}
                cols={cols}
                emptyRender={emptyRender}
                caption={headerRender}
                showHeader={tableInstance.data && tableInstance.data.length > 0}
                keyField=""
                pagination={true}
            ></Table>
            {maskRender}
        </div>
    )
}


const DocumentRuntime = (props: {docId: string}) => {

    const {docId} = props

    const [status, setStatus] = useState<string>("IN_PROGRESS")
    const [progress, setProgress] = useState<number>()
    const [hidden, setHidden] = useState<boolean>(false)

    const navigate = useNavigate()


    const onPreviewHandle = () => {
        navigate(`/app/preview?docId=${docId}`)
    }

    const isFinished = (status: string) => {
        return status === "COMPLETED" || status === "WAITING_PAYMENT" || status === "FAILED"
    }

    useEffect(() => {
        const scheduleId = setInterval(() => {
                documentApi.detail({id: docId}).then(res => {
                    setStatus(res.status)
                    setProgress(res.translation_progress_percentage??0)
                    if(isFinished(res.status)){
                        clearInterval(scheduleId)
                    }
                })
            
        }, 1000);
        return () => {
            clearInterval(scheduleId)
        }
        
        
    }, [])

    const statusRender = () => {
        if(status === "IN_PROGRESS"){
            return (
                <Flex>
                    <ProgressBar progress={progress} width={143} height={8} label="In progress" />
                </Flex>
            )
        }else{
            return (
                <Status label={status} type={status} />
            )
        }
    }

    return statusRender()
}

const DownloadRuntime = (props: {docId: string}) => {
    const {docId} = props
    const [status, setStatus] = useState<string>("IN_PROGRESS")
    const navigate = useNavigate()
    const {
        render: maskRender,
        show: showMask,
        close: closeMask
    } = useMask()
    const {t} = useTranslate()

    const isFinished = (status: string) => {
        return status === "COMPLETED" || status === "WAITING_PAYMENT" || status === "FAILED"
    }

    const doDownload = (docId: any, format: 'pdf' | 'pptx' = 'pdf') => {

        showMask(
            <ChoiceModal
                title={t("Download Format")}
                content={t("Please select the format you want to download")}
                onCancel={() => closeMask()}
                onChoice1={() => handleDownload(docId, 'pdf')}
                onChoice2={() => handleDownload(docId, 'pptx')}
                choice1Label={t("PDF")}
                choice2Label={t("PPTX")}
            />
        )
    }

    const handleDownload = (docId: any, format: 'pdf' | 'pptx' = 'pdf') => {
        closeMask()
        documentApi.getDownloadUrl({id: docId}, format).then(download_url => {
            window.open(download_url)
        })
    }

    useEffect(() => {
        const scheduleId = setInterval(() => {
                documentApi.detail({id: docId}).then(res => {
                    setStatus(res.status)
                    if(isFinished(res.status)){
                        clearInterval(scheduleId)
                    }
                })
            
        }, 1000);
        return () => {
            clearInterval(scheduleId)
        }
    }, [])


    if(status === "WAITING_PAYMENT"){
        return (
            <Icon src={previewPng} size={20} padding={16} hoverable onClick={() => {navigate(`/app/preview?docId=${docId}`)}}/>
        )
    }

    if(status === "COMPLETED"){
        return (
            <Icon src={download02Svg} size={20} padding={16} hoverable={status == "COMPLETED"} onClick={() => doDownload({id: docId})}/>
        )
    }
    

    return (
        <>
            <Icon src={download01Svg} size={20} padding={16} />
            {maskRender}
        </>

    )
}
